import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Button, Platform } from 'react-native';
import { MainColors } from '../../../../constants/Colors';
import FontSizes from '../../../../constants/FontSizes';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import DateTimePickerModal from "react-native-modal-datetime-picker";

function parseISOLocal(s) {
    // from https://stackoverflow.com/questions/33908299/javascript-parse-a-string-to-date-as-local-time-zone
    // parses a date of the format yyyy-mm-dd
    var b = s.split("-");
    console.log(b)
    return new Date(b[0], b[1]-1, b[2], 12); // set it to noon for whatever the chosen date was (local), and then convert to utc
}

const localToUtc = parseISOLocal
const utcToLocal = (date) => new Date(date).toLocaleDateString('fr-CA')

const DatePicker = (props) => {
    const [isFocused, setIsFocused] = useState(false);
    const [showPicker, setShowPicker] = useState(false);

    const date = props.value ? new Date(props.value) : new Date()
    console.log('date', date)
    console.log('datef', (date).toISOString().slice(0, 10))

    return (
        <View style={styles.container}>
            <Text style={[styles.label, isFocused ? styles.focusedLabel : styles.unFocusedLabel]}>
                {props.label}
            </Text>
            {Platform.OS === 'web'
                ?
                <input type='date'
                    style={{
                        paddingLeft: 12,
                        color: MainColors.darkGray,
                        backgroundColor: 'transparent',
                        borderColor: 'transparent',
                        fontWeight: '500',
                        fontSize: FontSizes.medium
                    }}
                    value={(utcToLocal(date))}
                    onChange={(e) => { props.onChangeText(localToUtc(e.target.value)) }}
                    placeholder='mm/dd/yyyy'
                    disabled={props.editable === false}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                />
                :
                <>
                    {
                        <TouchableOpacity style={styles.iconButton} disabled={props.disabled}
                            onPress={() => setShowPicker(true)}>
                            <MaterialCommunityIcons style={styles.icon} name="calendar-blank-outline" size={24} />
                            <Text>{date.toDateString()}</Text>
                        </TouchableOpacity>
                    }
                    {
                        // this thing operates on UTC entirely
                        showPicker &&
                        <DateTimePickerModal
                            // style={styles.picker}
                            value={date}
                            mode={'date'}
                            display={Platform.OS === 'ios' ? "inline" : 'default'}
                            isVisible={showPicker}
                            onConfirm={(date) => {
                                props.onChangeText(date);
                                setShowPicker(false);
                            }}
                            onCancel={() => setShowPicker(false)}
                            disabled={props.editable === false}
                        />
                    }
                </>
            }
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        marginBottom: 30,
        borderBottomWidth: 1,
        borderBottomColor: MainColors.lightGray
    },
    label: {
        fontSize: FontSizes.medium,
        marginBottom: 8,
        paddingLeft: 12,
        fontWeight: '500'
    },
    focusedLabel: {
        color: MainColors.primary,
    },
    unFocusedLabel: {
        color: MainColors.mediumGray
    },
    iconButton: {
        flex: 1,
        flexDirection: 'row',
        paddingVertical: 8,
        paddingHorizontal: 12,
        alignItems: 'center'
    },
    icon: {
        paddingRight: 8,
        color: MainColors.primary
    },
    picker: {
        // flex: 1,
        // backgroundColor: 'white',
    }
});

export default DatePicker;